/**
 * Privy configuration (@privy-io/react-auth 3.49). Login with Google, X or an external Solana wallet; users without a
 * wallet get a Solana embedded wallet on login. Solana only: no EVM wallets, no EVM embedded wallet.
 *
 * No Solana RPC is configured, on purpose: the browser makes no JSON-RPC calls (the API quotes, builds, relays and
 * confirms). Privy's own transaction screen for embedded wallets needs an RPC (it simulates and reads the balance),
 * so it is turned off: the app shows the server's full cost breakdown before every signature instead, and the
 * embedded wallet signs exactly the bytes the server built.
 */
import type { PrivyClientConfig } from '@privy-io/react-auth';
import { toSolanaWalletConnectors } from '@privy-io/react-auth/solana';

/** Public: the Privy app "Raydius". It must equal the server's PRIVY_APP_ID (the access token's audience). */
export const PRIVY_APP_ID: string = import.meta.env.VITE_PRIVY_APP_ID || 'cmv9a425r00r70gjgv862g8on';

/** Phantom, Solflare, Backpack and any other Wallet Standard wallet the browser has. */
const solanaConnectors = toSolanaWalletConnectors();

export const privyConfig: PrivyClientConfig = {
  loginMethods: ['google', 'twitter', 'wallet'],
  appearance: {
    theme: 'dark',
    accentColor: '#38d6ec',
    logo: '/icons/icon-512.png',
    walletChainType: 'solana-only',
    walletList: ['detected_solana_wallets', 'phantom', 'solflare', 'backpack'],
  },
  externalWallets: { solana: { connectors: solanaConnectors } },
  embeddedWallets: {
    solana: { createOnLogin: 'users-without-wallets' },
    ethereum: { createOnLogin: 'off' },
    showWalletUIs: false,
  },
};
